module.exports = __webpack_public_path__ + "static/img/1_hedian.0406082.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/1_hedian.png
// module id = KWv9
// module chunks = 0